import {connect} from "react-redux";
import LeadListing from "./list";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../service/Lead/action";

const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadListing);
